import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_inbound_lp_detailsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lp_id: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, ActualTargetLicensePlate?: { LookupCode?: string }, Order?: { LookupCode?: string }, Project?: { LookupCode?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { ShortName?: string }, VendorLot?: { ExpirationDate?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lp_id)) {
      $missingRequiredInParams.push('\'lp_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { lp_id: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, ActualTargetLicensePlate?: { LookupCode?: string }, Order?: { LookupCode?: string }, Project?: { LookupCode?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { ShortName?: string }, VendorLot?: { ExpirationDate?: string } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lp_id)) {
      $missingRequiredInParams.push('\'lp_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { lp_id: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, ActualTargetLicensePlate?: { LookupCode?: string }, Order?: { LookupCode?: string }, Project?: { LookupCode?: string }, Material?: { LookupCode?: string }, Lot?: { LookupCode?: string }, ActualPackagedPack?: { ShortName?: string }, VendorLot?: { ExpirationDate?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lp_id)) {
      $missingRequiredInParams.push('\'lp_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lp_id: number[]    }) {
        if(isNil($inParams.lp_id)) {
          return true; 
        }
      return false;
    }
}
